import { createSlice } from "@reduxjs/toolkit";

import OrderEntryModel from "models/OrderEntryModel";
import { initialResultsDtoModel, ResultsDtoModel } from 'models/ResultsDtoModel';

import { getOrders } from "services/order.service";

import { RootState } from "store/store";

interface OrderState {
    ordersDto: ResultsDtoModel<OrderEntryModel>;
    selectedOrder?: OrderEntryModel | null;
    loading: boolean;
    error?: string | null;
}

const initialState: OrderState = {
    ordersDto: initialResultsDtoModel,
    loading: false,
    selectedOrder: null,
    error: null
}

const demoOrders: OrderEntryModel[] = [
    {
        "salesOrder": "BCDSO0292070",
        "invoiceNumber": "",
        "itemFulfillmentId": "",
        "itemFulfillmentTranId": "",
        "invoiceId": 0,
        "shipDate": new Date(),
        "estimatedShipDate": new Date(),
        "serialNumbers": "",
        "trackingNumbers": "",
        "shipper": "UPS� Ground",
        "itemName": "",
        "itemDescription": "",
        "itemQuantity": "",
        "transactionId": 62432915,
        "purchaseOrder": "5005087790",
        "fileId": 1,
        "transactionDate": new Date(),
        "status": "Pending Billing",
        "qcNotes": ""
    },{
        "salesOrder": "BCDSO0292002",
        "invoiceNumber": "",
        "itemFulfillmentId": "",
        "itemFulfillmentTranId": "",
        "invoiceId": 0,
        "shipDate": new Date(),
        "estimatedShipDate": new Date(),
        "serialNumbers": "",
        "trackingNumbers": "",
        "shipper": "UPS� Ground",
        "itemName": "",
        "itemDescription": "",
        "itemQuantity": "",
        "transactionId": 62493215,
        "purchaseOrder": "50050877902",
        "fileId": 1,
        "transactionDate": new Date(),
        "status": "Billed",
        "qcNotes": ""
    },
    {
        "salesOrder": "BCDSO0292040",
        "invoiceNumber": "",
        "itemFulfillmentId": "",
        "itemFulfillmentTranId": "",
        "invoiceId": 0,
        "shipDate": new Date(),
        "estimatedShipDate": new Date(),
        "serialNumbers": "",
        "trackingNumbers": "",
        "shipper": "UPS� Ground",
        "itemName": "",
        "itemDescription": "",
        "itemQuantity": "",
        "transactionId": 34624915,
        "purchaseOrder": "58465005087790",
        "fileId": 1,
        "transactionDate": new Date(),
        "status": "Pending Fulfillment",
        "qcNotes": ""
    },
    {
        "salesOrder": "BCDSO0292700",
        "invoiceNumber": "",
        "itemFulfillmentId": "",
        "itemFulfillmentTranId": "",
        "invoiceId": 0,
        "shipDate": new Date(),
        "estimatedShipDate": new Date(),
        "serialNumbers": "",
        "trackingNumbers": "",
        "shipper": "UPS� Ground",
        "itemName": "",
        "itemDescription": "",
        "itemQuantity": "",
        "transactionId": 23624915,
        "purchaseOrder": "58465005087790",
        "fileId": 1,
        "transactionDate": new Date(),
        "status": "Pending Billing",
        "qcNotes": ""
    },
    {
        "salesOrder": "BCDSO0292800",
        "invoiceNumber": "",
        "itemFulfillmentId": "",
        "itemFulfillmentTranId": "",
        "invoiceId": 0,
        "shipDate": new Date(),
        "estimatedShipDate": new Date(),
        "serialNumbers": "",
        "trackingNumbers": "",
        "shipper": "UPS� Ground",
        "itemName": "",
        "itemDescription": "",
        "itemQuantity": "",
        "transactionId": 23623915,
        "purchaseOrder": "58465005087790",
        "fileId": 1,
        "transactionDate": new Date(),
        "status": "Billed",
        "qcNotes": ""
    },
    {
        "salesOrder": "BCDSO0292090",
        "invoiceNumber": "",
        "itemFulfillmentId": "",
        "itemFulfillmentTranId": "",
        "invoiceId": 0,
        "shipDate": new Date(),
        "estimatedShipDate": new Date(),
        "serialNumbers": "",
        "trackingNumbers": "",
        "shipper": "UPS� Ground",
        "itemName": "",
        "itemDescription": "",
        "itemQuantity": "",
        "transactionId": 12624915,
        "purchaseOrder": "50058465087790",
        "fileId": 1,
        "transactionDate": new Date(),
        "status": "Pending Fulfillment",
        "qcNotes": ""
    },
]

export const ordersSlice = createSlice({
    name: "orders",
    initialState,
    reducers: {
        clearOrders: (state) => {
            state = initialState;
        },
        setOrder: (state, action) => {
            state.selectedOrder = state.ordersDto.items.find(o => o.transactionId === action.payload);
        },
        clearOrder: (state) => {
            state.selectedOrder = null;
        },
        setDemoOrders: (state) => {
            state.ordersDto.items = demoOrders
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getOrders.fulfilled, (state, action) => {
                state.ordersDto = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getOrders.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getOrders.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'Failed to load orders';
            })
    }
});

export const getOrderById = (
    orders: OrderEntryModel[],
    transactionId: number | string
) => {
    return orders.find(c => c.transactionId === transactionId);
};

export const selectOrdersDto = (state: RootState) => state.orders.ordersDto;
export const ordersReducer = ordersSlice.reducer;
export const { clearOrders, setOrder, clearOrder, setDemoOrders } = ordersSlice.actions;